export default "__VITE_ASSET__a376090a__"